import { BookedFlightItinerary } from "@b2bportal/air-booking-api";
import { TripDetails } from "redmond";

const BOOKING_CONFIRMATION_KEY = "flights_booking_confirmation";
const DP_PRODUCT_VARIANT_KEY = "flights_dp_product_variant";

interface BookingConfirmationData {
  tripDetails: TripDetails;
  itinerary: BookedFlightItinerary;
  destinationCountryCode?: string;
}

export const saveBookingConfirmation = (
  tripDetails: TripDetails,
  itinerary: BookedFlightItinerary,
  destinationCountryCode?: string
): void => {
  try {
    sessionStorage.setItem(
      BOOKING_CONFIRMATION_KEY,
      JSON.stringify({ tripDetails, itinerary, destinationCountryCode })
    );
  } catch (e) {
    console.error("Failed to save booking confirmation to sessionStorage", e);
  }
};

export const getBookingConfirmation = (): BookingConfirmationData | null => {
  try {
    const saved = sessionStorage.getItem(BOOKING_CONFIRMATION_KEY);
    if (saved) {
      return JSON.parse(saved);
    }
  } catch (e) {
    console.error(
      "Failed to retrieve booking confirmation from sessionStorage",
      e
    );
  }
  return null;
};

export const clearBookingConfirmation = (): void => {
  try {
    sessionStorage.removeItem(BOOKING_CONFIRMATION_KEY);
  } catch (e) {
    console.error(
      "Failed to clear booking confirmation from sessionStorage",
      e
    );
  }
};

export const saveDpProductVariant = (productVariant: string): void => {
  try {
    sessionStorage.setItem(DP_PRODUCT_VARIANT_KEY, productVariant);
  } catch (e) {
    console.error("Failed to save DP product variant to sessionStorage", e);
  }
};

export const getDpProductVariant = (): string | undefined => {
  try {
    return sessionStorage.getItem(DP_PRODUCT_VARIANT_KEY) ?? undefined;
  } catch (e) {
    console.error(
      "Failed to retrieve DP product variant from sessionStorage",
      e
    );
  }
  return undefined;
};

export const clearDpProductVariant = (): void => {
  try {
    sessionStorage.removeItem(DP_PRODUCT_VARIANT_KEY);
  } catch (e) {
    console.error(
      "Failed to clear DP product variant from sessionStorage",
      e
    );
  }
};
